import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";
import { PropertySchema } from "../../properties/response/ShowPropertiesResponse";
import { BookingSchema } from "../../booking/response/ShowBookingResponse";

export const PaymentSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    booking_id: z.string(),
    booking_room_id: z.string(),
    user_id: z.nullable(z.string()).optional(),
    date_payment: z.string(),
    payment_type: z.string(),
    amount: z.string(),
    surcharge: z.string().optional(),
    created_at: z.nullable(z.string().datetime()).optional(),
    updated_at: z.nullable(z.string().datetime()).optional(),
    property: PropertySchema.optional(),
    booking_room: BookingSchema.optional(),
});
export const IndexPaymentResponseSchema = BaseResponseSchema(z.array(PaymentSchema));
export type IndexPaymentResponse = z.infer<typeof IndexPaymentResponseSchema>;